export default __webpack_public_path__ + "locales/es/PrivacyPage.json?hash=a8f245e1edaa0e0bed694aa841dfa379";